import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import ProofpointLoadingBar from './components/proofpoint-loading-bar';

import { connect } from 'react-redux';
import { debounce } from 'lodash';
import { validateSession } from './actions/authentication-action-creators';
import {
    isInitialLoadSelector,
    isSessionValidSelector,
} from './selectors/ui-state-selectors';

export class PrivateRoute extends Component{

    componentDidMount(){
        const { validateSession } = this.props;
        validateSession();
    }

    componentDidUpdate(){
        const { validateSession } = this.props;
        debounce( validateSession, 1000, { maxWait: 5000 } );
    }

    render(){
        const {
            component: Component,
            isInitialLoad,
            isSessionValid,
            ...rest
        } = this.props;

        return (
            <Route
                {...rest}
                render={props => {

                    if( isInitialLoad ){
                        return <ProofpointLoadingBar />;
                    }
                    else{
                        return isSessionValid ? (
                            <Component
                                key="component"
                                {...props}
                            />
                        ) : (
                            <Redirect
                                to={{
                                    pathname: '/login',
                                    state: { from: props.location }
                                }}
                            />
                        );
                    }
                }
                }
            />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        isInitialLoad: isInitialLoadSelector( state ),
        isSessionValid: isSessionValidSelector( state ),
    };
};

PrivateRoute.propTypes = {
    component: PropTypes.any,
    isInitialLoad: PropTypes.bool.isRequired,
    isSessionValid: PropTypes.bool.isRequired,
    validateSession: PropTypes.func.isRequired,
};

export default connect( mapStateToProps, { validateSession } )( PrivateRoute );
